<template>
    <div id="contenedor-solicitudes-obras-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'SolicitudesObrasMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
